package flagpack.icons

import androidx.compose.ui.graphics.vector.ImageVector
import flagpack.icons.small.Afghanistan
import flagpack.icons.small.AlandIslands
import flagpack.icons.small.Albania
import flagpack.icons.small.Algeria
import flagpack.icons.small.AmericanSamoa
import flagpack.icons.small.Andorra
import flagpack.icons.small.Angola
import flagpack.icons.small.Anguilla
import flagpack.icons.small.Antarctica
import flagpack.icons.small.AntiguaAndBarbuda
import flagpack.icons.small.Argentina
import flagpack.icons.small.Armenia
import flagpack.icons.small.Aruba
import flagpack.icons.small.Australia
import flagpack.icons.small.Austria
import flagpack.icons.small.Azerbaijan
import flagpack.icons.small.Bahamas
import flagpack.icons.small.Bahrain
import flagpack.icons.small.Bangladesh
import flagpack.icons.small.Barbados
import flagpack.icons.small.Belarus
import flagpack.icons.small.Belgium
import flagpack.icons.small.Belize
import flagpack.icons.small.Benin
import flagpack.icons.small.Bermuda
import flagpack.icons.small.Bhutan
import flagpack.icons.small.Bolivia
import flagpack.icons.small.Bonaire
import flagpack.icons.small.BosniaAndHerzegovina
import flagpack.icons.small.Botswana
import flagpack.icons.small.BouvetIsland
import flagpack.icons.small.Brazil
import flagpack.icons.small.BritishIndianOceanTerritory
import flagpack.icons.small.BritishVirginIslands
import flagpack.icons.small.Brunei
import flagpack.icons.small.Bulgaria
import flagpack.icons.small.BurkinaFaso
import flagpack.icons.small.Burundi
import flagpack.icons.small.Cambodia
import flagpack.icons.small.Cameroon
import flagpack.icons.small.Canada
import flagpack.icons.small.CapeVerde
import flagpack.icons.small.CaymanIslands
import flagpack.icons.small.CentralAfricanRepublic
import flagpack.icons.small.Chad
import flagpack.icons.small.Chile
import flagpack.icons.small.China
import flagpack.icons.small.ChristmasIsland
import flagpack.icons.small.CocosIslands
import flagpack.icons.small.Colombia
import flagpack.icons.small.Comoros
import flagpack.icons.small.Congo
import flagpack.icons.small.CookIslands
import flagpack.icons.small.CostaRica
import flagpack.icons.small.CoteDivoire
import flagpack.icons.small.Croatia
import flagpack.icons.small.Cuba
import flagpack.icons.small.Curacao
import flagpack.icons.small.Cyprus
import flagpack.icons.small.CzechRepublic
import flagpack.icons.small.DemocraticRepublicOfCongo
import flagpack.icons.small.Denmark
import flagpack.icons.small.Djibouti
import flagpack.icons.small.Dominica
import flagpack.icons.small.DominicanRepublic
import flagpack.icons.small.Ecuador
import flagpack.icons.small.Egypt
import flagpack.icons.small.ElSalvador
import flagpack.icons.small.England
import flagpack.icons.small.EquatorialGuinea
import flagpack.icons.small.Eritrea
import flagpack.icons.small.Estonia
import flagpack.icons.small.Eswatini
import flagpack.icons.small.Ethiopia
import flagpack.icons.small.FalklandIslands
import flagpack.icons.small.FaroeIslands
import flagpack.icons.small.Fiji
import flagpack.icons.small.Finland
import flagpack.icons.small.France
import flagpack.icons.small.FrenchGuiana
import flagpack.icons.small.FrenchPolynesia
import flagpack.icons.small.FrenchSouthernTerritories
import flagpack.icons.small.Gabon
import flagpack.icons.small.Gambia
import flagpack.icons.small.Georgia
import flagpack.icons.small.Germany
import flagpack.icons.small.Ghana
import flagpack.icons.small.Gibraltar
import flagpack.icons.small.Greece
import flagpack.icons.small.Greenland
import flagpack.icons.small.Grenada
import flagpack.icons.small.Guadeloupe
import flagpack.icons.small.Guam
import flagpack.icons.small.Guatemala
import flagpack.icons.small.Guernsey
import flagpack.icons.small.Guinea
import flagpack.icons.small.GuineaBissau
import flagpack.icons.small.Guyana
import flagpack.icons.small.Haiti
import flagpack.icons.small.HeardIslandAndMcdonaldIslands
import flagpack.icons.small.Honduras
import flagpack.icons.small.HongKong
import flagpack.icons.small.Hungary
import flagpack.icons.small.Iceland
import flagpack.icons.small.India
import flagpack.icons.small.Indonesia
import flagpack.icons.small.Iran
import flagpack.icons.small.Iraq
import flagpack.icons.small.Ireland
import flagpack.icons.small.IsleOfMan
import flagpack.icons.small.Israel
import flagpack.icons.small.Italy
import flagpack.icons.small.Jamaica
import flagpack.icons.small.Japan
import flagpack.icons.small.Jersey
import flagpack.icons.small.Jordan
import flagpack.icons.small.Kazakhstan
import flagpack.icons.small.Kenya
import flagpack.icons.small.Kiribati
import flagpack.icons.small.Kuwait
import flagpack.icons.small.Kyrgyzstan
import flagpack.icons.small.Laos
import flagpack.icons.small.Latvia
import flagpack.icons.small.Lebanon
import flagpack.icons.small.Lesotho
import flagpack.icons.small.Liberia
import flagpack.icons.small.Libya
import flagpack.icons.small.Liechtenstein
import flagpack.icons.small.Lithuania
import flagpack.icons.small.Luxembourg
import flagpack.icons.small.Macao
import flagpack.icons.small.Madagascar
import flagpack.icons.small.Malawi
import flagpack.icons.small.Malaysia
import flagpack.icons.small.Maldives
import flagpack.icons.small.Mali
import flagpack.icons.small.Malta
import flagpack.icons.small.MarshallIslands
import flagpack.icons.small.Martinique
import flagpack.icons.small.Mauritania
import flagpack.icons.small.Mauritius
import flagpack.icons.small.Mayotte
import flagpack.icons.small.Mexico
import flagpack.icons.small.Micronesia
import flagpack.icons.small.Moldova
import flagpack.icons.small.Monaco
import flagpack.icons.small.Mongolia
import flagpack.icons.small.Montenegro
import flagpack.icons.small.Montserrat
import flagpack.icons.small.Morocco
import flagpack.icons.small.Mozambique
import flagpack.icons.small.Myanmar
import flagpack.icons.small.Namibia
import flagpack.icons.small.Nauru
import flagpack.icons.small.Nepal
import flagpack.icons.small.Netherlands
import flagpack.icons.small.NewCaledonia
import flagpack.icons.small.NewZealand
import flagpack.icons.small.Nicaragua
import flagpack.icons.small.Niger
import flagpack.icons.small.Nigeria
import flagpack.icons.small.Niue
import flagpack.icons.small.NorfolkIsland
import flagpack.icons.small.NorthKorea
import flagpack.icons.small.NorthMacedonia
import flagpack.icons.small.NorthernIreland
import flagpack.icons.small.NorthernMarianaIslands
import flagpack.icons.small.Norway
import flagpack.icons.small.Oman
import flagpack.icons.small.Pakistan
import flagpack.icons.small.Palau
import flagpack.icons.small.Palestine
import flagpack.icons.small.Panama
import flagpack.icons.small.PapuaNewGuinea
import flagpack.icons.small.Paraguay
import flagpack.icons.small.Peru
import flagpack.icons.small.Philippines
import flagpack.icons.small.PitcairnIslands
import flagpack.icons.small.Poland
import flagpack.icons.small.Portugal
import flagpack.icons.small.PuertoRico
import flagpack.icons.small.Qatar
import flagpack.icons.small.Reunion
import flagpack.icons.small.Romania
import flagpack.icons.small.Russia
import flagpack.icons.small.Rwanda
import flagpack.icons.small.Saba
import flagpack.icons.small.SaintBarthelemy
import flagpack.icons.small.SaintHelena
import flagpack.icons.small.SaintKittsAndNevis
import flagpack.icons.small.SaintLucia
import flagpack.icons.small.SaintMartin
import flagpack.icons.small.SaintPierreAndMiquelon
import flagpack.icons.small.SaintVincentAndTheGrenadines
import flagpack.icons.small.Samoa
import flagpack.icons.small.SanMarino
import flagpack.icons.small.SaoTomeAndPrincipe
import flagpack.icons.small.SaudiArabia
import flagpack.icons.small.Scotland
import flagpack.icons.small.Senegal
import flagpack.icons.small.Serbia
import flagpack.icons.small.Seychelles
import flagpack.icons.small.SierraLeone
import flagpack.icons.small.Singapore
import flagpack.icons.small.SintEustatius
import flagpack.icons.small.SintMaarten
import flagpack.icons.small.Slovakia
import flagpack.icons.small.Slovenia
import flagpack.icons.small.SolomonIslands
import flagpack.icons.small.Somalia
import flagpack.icons.small.SouthAfrica
import flagpack.icons.small.SouthGeorgia
import flagpack.icons.small.SouthKorea
import flagpack.icons.small.SouthSudan
import flagpack.icons.small.Spain
import flagpack.icons.small.SriLanka
import flagpack.icons.small.Sudan
import flagpack.icons.small.Suriname
import flagpack.icons.small.SvalbardAndJanMayen
import flagpack.icons.small.Sweden
import flagpack.icons.small.Switzerland
import flagpack.icons.small.Syria
import flagpack.icons.small.Taiwan
import flagpack.icons.small.Tajikistan
import flagpack.icons.small.Tanzania
import flagpack.icons.small.Thailand
import flagpack.icons.small.TimorLeste
import flagpack.icons.small.Togo
import flagpack.icons.small.Tokelau
import flagpack.icons.small.Tonga
import flagpack.icons.small.TrinidadAndTobago
import flagpack.icons.small.Tunisia
import flagpack.icons.small.Turkey
import flagpack.icons.small.Turkmenistan
import flagpack.icons.small.TurksAndCaicosIslands
import flagpack.icons.small.Tuvalu
import flagpack.icons.small.Uganda
import flagpack.icons.small.Ukraine
import flagpack.icons.small.UnitedArabEmirates
import flagpack.icons.small.UnitedKingdom
import flagpack.icons.small.UnitedStates
import flagpack.icons.small.Uruguay
import flagpack.icons.small.UsMinorOutlyingIslands
import flagpack.icons.small.UsVirginIslands
import flagpack.icons.small.Uzbekistan
import flagpack.icons.small.Vanuatu
import flagpack.icons.small.VaticanCity
import flagpack.icons.small.Venezuela
import flagpack.icons.small.Vietnam
import flagpack.icons.small.Wales
import flagpack.icons.small.WallisAndFutuna
import flagpack.icons.small.WesternSahara
import flagpack.icons.small.Yemen
import flagpack.icons.small.Zambia
import flagpack.icons.small.Zimbabwe

/**
 * List of all Small (16x12dp) flag icons.
 *
 * Contains 255 flags, lazily initialized.
 */
public val FlagIcons.SmallFlagList: List<ImageVector>
    get() {
        if (_smallFlagList != null) {
            return _smallFlagList!!
        }
        _smallFlagList = listOf(
            FlagIcons.Small.Afghanistan,
            FlagIcons.Small.AlandIslands,
            FlagIcons.Small.Albania,
            FlagIcons.Small.Algeria,
            FlagIcons.Small.AmericanSamoa,
            FlagIcons.Small.Andorra,
            FlagIcons.Small.Angola,
            FlagIcons.Small.Anguilla,
            FlagIcons.Small.Antarctica,
            FlagIcons.Small.AntiguaAndBarbuda,
            FlagIcons.Small.Argentina,
            FlagIcons.Small.Armenia,
            FlagIcons.Small.Aruba,
            FlagIcons.Small.Australia,
            FlagIcons.Small.Austria,
            FlagIcons.Small.Azerbaijan,
            FlagIcons.Small.Bahamas,
            FlagIcons.Small.Bahrain,
            FlagIcons.Small.Bangladesh,
            FlagIcons.Small.Barbados,
            FlagIcons.Small.Belarus,
            FlagIcons.Small.Belgium,
            FlagIcons.Small.Belize,
            FlagIcons.Small.Benin,
            FlagIcons.Small.Bermuda,
            FlagIcons.Small.Bhutan,
            FlagIcons.Small.Bolivia,
            FlagIcons.Small.Bonaire,
            FlagIcons.Small.BosniaAndHerzegovina,
            FlagIcons.Small.Botswana,
            FlagIcons.Small.BouvetIsland,
            FlagIcons.Small.Brazil,
            FlagIcons.Small.BritishIndianOceanTerritory,
            FlagIcons.Small.BritishVirginIslands,
            FlagIcons.Small.Brunei,
            FlagIcons.Small.Bulgaria,
            FlagIcons.Small.BurkinaFaso,
            FlagIcons.Small.Burundi,
            FlagIcons.Small.Cambodia,
            FlagIcons.Small.Cameroon,
            FlagIcons.Small.Canada,
            FlagIcons.Small.CapeVerde,
            FlagIcons.Small.CaymanIslands,
            FlagIcons.Small.CentralAfricanRepublic,
            FlagIcons.Small.Chad,
            FlagIcons.Small.Chile,
            FlagIcons.Small.China,
            FlagIcons.Small.ChristmasIsland,
            FlagIcons.Small.CocosIslands,
            FlagIcons.Small.Colombia,
            FlagIcons.Small.Comoros,
            FlagIcons.Small.Congo,
            FlagIcons.Small.CookIslands,
            FlagIcons.Small.CostaRica,
            FlagIcons.Small.CoteDivoire,
            FlagIcons.Small.Croatia,
            FlagIcons.Small.Cuba,
            FlagIcons.Small.Curacao,
            FlagIcons.Small.Cyprus,
            FlagIcons.Small.CzechRepublic,
            FlagIcons.Small.DemocraticRepublicOfCongo,
            FlagIcons.Small.Denmark,
            FlagIcons.Small.Djibouti,
            FlagIcons.Small.Dominica,
            FlagIcons.Small.DominicanRepublic,
            FlagIcons.Small.Ecuador,
            FlagIcons.Small.Egypt,
            FlagIcons.Small.ElSalvador,
            FlagIcons.Small.England,
            FlagIcons.Small.EquatorialGuinea,
            FlagIcons.Small.Eritrea,
            FlagIcons.Small.Estonia,
            FlagIcons.Small.Eswatini,
            FlagIcons.Small.Ethiopia,
            FlagIcons.Small.FalklandIslands,
            FlagIcons.Small.FaroeIslands,
            FlagIcons.Small.Fiji,
            FlagIcons.Small.Finland,
            FlagIcons.Small.France,
            FlagIcons.Small.FrenchGuiana,
            FlagIcons.Small.FrenchPolynesia,
            FlagIcons.Small.FrenchSouthernTerritories,
            FlagIcons.Small.Gabon,
            FlagIcons.Small.Gambia,
            FlagIcons.Small.Georgia,
            FlagIcons.Small.Germany,
            FlagIcons.Small.Ghana,
            FlagIcons.Small.Gibraltar,
            FlagIcons.Small.Greece,
            FlagIcons.Small.Greenland,
            FlagIcons.Small.Grenada,
            FlagIcons.Small.Guadeloupe,
            FlagIcons.Small.Guam,
            FlagIcons.Small.Guatemala,
            FlagIcons.Small.Guernsey,
            FlagIcons.Small.Guinea,
            FlagIcons.Small.GuineaBissau,
            FlagIcons.Small.Guyana,
            FlagIcons.Small.Haiti,
            FlagIcons.Small.HeardIslandAndMcdonaldIslands,
            FlagIcons.Small.Honduras,
            FlagIcons.Small.HongKong,
            FlagIcons.Small.Hungary,
            FlagIcons.Small.Iceland,
            FlagIcons.Small.India,
            FlagIcons.Small.Indonesia,
            FlagIcons.Small.Iran,
            FlagIcons.Small.Iraq,
            FlagIcons.Small.Ireland,
            FlagIcons.Small.IsleOfMan,
            FlagIcons.Small.Israel,
            FlagIcons.Small.Italy,
            FlagIcons.Small.Jamaica,
            FlagIcons.Small.Japan,
            FlagIcons.Small.Jersey,
            FlagIcons.Small.Jordan,
            FlagIcons.Small.Kazakhstan,
            FlagIcons.Small.Kenya,
            FlagIcons.Small.Kiribati,
            FlagIcons.Small.Kuwait,
            FlagIcons.Small.Kyrgyzstan,
            FlagIcons.Small.Laos,
            FlagIcons.Small.Latvia,
            FlagIcons.Small.Lebanon,
            FlagIcons.Small.Lesotho,
            FlagIcons.Small.Liberia,
            FlagIcons.Small.Libya,
            FlagIcons.Small.Liechtenstein,
            FlagIcons.Small.Lithuania,
            FlagIcons.Small.Luxembourg,
            FlagIcons.Small.Macao,
            FlagIcons.Small.Madagascar,
            FlagIcons.Small.Malawi,
            FlagIcons.Small.Malaysia,
            FlagIcons.Small.Maldives,
            FlagIcons.Small.Mali,
            FlagIcons.Small.Malta,
            FlagIcons.Small.MarshallIslands,
            FlagIcons.Small.Martinique,
            FlagIcons.Small.Mauritania,
            FlagIcons.Small.Mauritius,
            FlagIcons.Small.Mayotte,
            FlagIcons.Small.Mexico,
            FlagIcons.Small.Micronesia,
            FlagIcons.Small.Moldova,
            FlagIcons.Small.Monaco,
            FlagIcons.Small.Mongolia,
            FlagIcons.Small.Montenegro,
            FlagIcons.Small.Montserrat,
            FlagIcons.Small.Morocco,
            FlagIcons.Small.Mozambique,
            FlagIcons.Small.Myanmar,
            FlagIcons.Small.Namibia,
            FlagIcons.Small.Nauru,
            FlagIcons.Small.Nepal,
            FlagIcons.Small.Netherlands,
            FlagIcons.Small.NewCaledonia,
            FlagIcons.Small.NewZealand,
            FlagIcons.Small.Nicaragua,
            FlagIcons.Small.Niger,
            FlagIcons.Small.Nigeria,
            FlagIcons.Small.Niue,
            FlagIcons.Small.NorfolkIsland,
            FlagIcons.Small.NorthKorea,
            FlagIcons.Small.NorthMacedonia,
            FlagIcons.Small.NorthernIreland,
            FlagIcons.Small.NorthernMarianaIslands,
            FlagIcons.Small.Norway,
            FlagIcons.Small.Oman,
            FlagIcons.Small.Pakistan,
            FlagIcons.Small.Palau,
            FlagIcons.Small.Palestine,
            FlagIcons.Small.Panama,
            FlagIcons.Small.PapuaNewGuinea,
            FlagIcons.Small.Paraguay,
            FlagIcons.Small.Peru,
            FlagIcons.Small.Philippines,
            FlagIcons.Small.PitcairnIslands,
            FlagIcons.Small.Poland,
            FlagIcons.Small.Portugal,
            FlagIcons.Small.PuertoRico,
            FlagIcons.Small.Qatar,
            FlagIcons.Small.Reunion,
            FlagIcons.Small.Romania,
            FlagIcons.Small.Russia,
            FlagIcons.Small.Rwanda,
            FlagIcons.Small.Saba,
            FlagIcons.Small.SaintBarthelemy,
            FlagIcons.Small.SaintHelena,
            FlagIcons.Small.SaintKittsAndNevis,
            FlagIcons.Small.SaintLucia,
            FlagIcons.Small.SaintMartin,
            FlagIcons.Small.SaintPierreAndMiquelon,
            FlagIcons.Small.SaintVincentAndTheGrenadines,
            FlagIcons.Small.Samoa,
            FlagIcons.Small.SanMarino,
            FlagIcons.Small.SaoTomeAndPrincipe,
            FlagIcons.Small.SaudiArabia,
            FlagIcons.Small.Scotland,
            FlagIcons.Small.Senegal,
            FlagIcons.Small.Serbia,
            FlagIcons.Small.Seychelles,
            FlagIcons.Small.SierraLeone,
            FlagIcons.Small.Singapore,
            FlagIcons.Small.SintEustatius,
            FlagIcons.Small.SintMaarten,
            FlagIcons.Small.Slovakia,
            FlagIcons.Small.Slovenia,
            FlagIcons.Small.SolomonIslands,
            FlagIcons.Small.Somalia,
            FlagIcons.Small.SouthAfrica,
            FlagIcons.Small.SouthGeorgia,
            FlagIcons.Small.SouthKorea,
            FlagIcons.Small.SouthSudan,
            FlagIcons.Small.Spain,
            FlagIcons.Small.SriLanka,
            FlagIcons.Small.Sudan,
            FlagIcons.Small.Suriname,
            FlagIcons.Small.SvalbardAndJanMayen,
            FlagIcons.Small.Sweden,
            FlagIcons.Small.Switzerland,
            FlagIcons.Small.Syria,
            FlagIcons.Small.Taiwan,
            FlagIcons.Small.Tajikistan,
            FlagIcons.Small.Tanzania,
            FlagIcons.Small.Thailand,
            FlagIcons.Small.TimorLeste,
            FlagIcons.Small.Togo,
            FlagIcons.Small.Tokelau,
            FlagIcons.Small.Tonga,
            FlagIcons.Small.TrinidadAndTobago,
            FlagIcons.Small.Tunisia,
            FlagIcons.Small.Turkey,
            FlagIcons.Small.Turkmenistan,
            FlagIcons.Small.TurksAndCaicosIslands,
            FlagIcons.Small.Tuvalu,
            FlagIcons.Small.Uganda,
            FlagIcons.Small.Ukraine,
            FlagIcons.Small.UnitedArabEmirates,
            FlagIcons.Small.UnitedKingdom,
            FlagIcons.Small.UnitedStates,
            FlagIcons.Small.Uruguay,
            FlagIcons.Small.UsMinorOutlyingIslands,
            FlagIcons.Small.UsVirginIslands,
            FlagIcons.Small.Uzbekistan,
            FlagIcons.Small.Vanuatu,
            FlagIcons.Small.VaticanCity,
            FlagIcons.Small.Venezuela,
            FlagIcons.Small.Vietnam,
            FlagIcons.Small.Wales,
            FlagIcons.Small.WallisAndFutuna,
            FlagIcons.Small.WesternSahara,
            FlagIcons.Small.Yemen,
            FlagIcons.Small.Zambia,
            FlagIcons.Small.Zimbabwe
        )
        return _smallFlagList!!
    }

@Suppress("ObjectPropertyName")
private var _smallFlagList: List<ImageVector>? = null
